import React from "react"
import { Avatar, Button, Chip, Container, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { Link, graphql } from "gatsby"

import PortableText from "../components/portableText"
import TitrePage from "../components/titrePage"

export const query = graphql`
  query($id: String!) {
    post: sanityPost(id: { eq: $id }) {
      publishedAt
      title
      authors {
        author {
          id
          image {
            asset {
              fixed(height: 50, width: 50) {
                src
              }
            }
          }
          name
        }
      }
      categories {
        id
        title
      }
      mainImage {
        asset {
          fixed(height: 400, width: 600) {
            src
          }
        }
        alt
      }
      _rawBody(resolveReferences: { maxDepth: 10 })
    }
  }
`

export default function Post({ data: { post } }) {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <section className={classes.section}>
      <TitrePage titre={post.title} />
      <Container className={classes.container}>
        <Button color="primary">
          <Link to={`/blog`} className={classes.link}>
            {t("blog.retour")}
          </Link>
        </Button>
        <hr />
        <div className={classes.ligneDate}>
          <span className={classes.date}>
            {new Intl.DateTimeFormat("fr").format(new Date(post.publishedAt))}
          </span>
          {post.categories.map(category => (
            <Chip
              className={classes.chip}
              label={category.title}
              color="secondary"
              key={category.id}
              size="small"
            />
          ))}
          {post.authors.map(a => (
            <Chip
              label={a.author.name}
              color="primary"
              key={a.author.id}
              size="small"
              avatar={<Avatar src={a.author.image.asset.fixed.src} />}
            />
          ))}
        </div>
        <img
          src={post.mainImage.asset.fixed.src}
          alt={post.mainImage.alt}
          className={classes.imgHero}
        />

        <PortableText blocks={post._rawBody} />
        <hr />
        <Button color="primary">
          <Link to={`/blog`} className={classes.link}>
            {t("blog.retour")}
          </Link>
        </Button>
      </Container>
    </section>
  )
}

const useStyles = makeStyles(theme => ({
  section: {
    flexGrow: 1,
    backgroundColor: theme.palette.bgwhite,
    color: "primary",
    margin: "0px auto",
  },
  container: {
    maxWidth: "980px",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:visited": { color: theme.palette.primary.main },
  },
  date: {
    color: theme.palette.lightgrey,
    fontSize: "80%",
    fontWeight: 400,
    marginRight: "1rem",
  },
  ligneDate: {
    padding: "0.5rem 0",
  },
  chip: {
    marginRight: "0.5rem",
  },
  imgHero: {
    width: "100%",
    height: "auto",
  },
}))
